import React, { createContext } from 'react';
import { GraphQLClient } from 'graphql-request';
import { baseURL } from 'utils/api';

import { useAuth } from './auth';

const FetchContext = createContext();
const { Provider } = FetchContext;

const FetchProvider = (props) => {
  const { user } = useAuth();

  const client = new GraphQLClient(baseURL, {
    mode: 'cors',
    headers: {
      authorization: `Bearer ${user?.token}`,
    },
  });

  return (
    <Provider
      value={{
        client,
      }}
      {...props}
    />
  );
};

const useFetch = () => React.useContext(FetchContext);

export { FetchProvider, useFetch };
